exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#app{\r\n  width: 100%;\r\n  height: 100%;\n}\r\n", "", {"version":3,"sources":["F:/迈锐租车/迈锐租车2/web/src/src/App.vue"],"names":[],"mappings":";AAyBA;EACA,YAAA;EACA,aAAA;CACA","file":"App.vue","sourcesContent":["<template>\r\n  <div id=\"app\">\r\n    <router-view />\r\n  </div>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  name: 'App',\r\n  provide () {\r\n\r\n  },\r\n  data () {\r\n    return {}\r\n  },\r\n  methods: {\r\n\r\n  },\r\n  mounted () {\r\n\r\n  }\r\n}\r\n</script>\r\n\r\n<style>\r\n#app{\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = z/+d
// module chunks = 43